import apiCall from '../../../utility/api';

type dataProps = {
  setDevicesOfTenant: any;
  selectedDevices: any;
  devicesOfTenant: null;
  selectedValue: number;
  classificationName: any;
  selectedRowIdInSubTable: any;
  selectedRowIdInTable: any;
  tenant: any;
  deviceSearchVal: any;
  setAddDevices: any;
  setDeleteDevices: any;
  setOverlayOpen: any;
  setIsToast: any;
  setDevicesData: any;
  setExportDetails: any;
  setSelectedDevices: any;
  data: any;
  func: any;
  searchVal: any
  pageNo: any
  setTotalPages: any
  setTotalRecords: any
  isFilter?: any
  dropDownValue1?: any
  setIsFilter?: any
  dropDownValue2?: any
  deleteDevices: any
  addDevices: any
  isRefresh?: any,
  setIsRefresh?: any
  setRefreshToast?: any
  filterArray?: any
  setErrorToast?: any
  setToastMessage?: any
}

const Device_classification_devices_func = (props: dataProps) => {
  const getDevicesList = async (condition: object, type: string) => {
    try {
      const { status, data } = await apiCall(`/census/getCensus`, condition);

      if (status === 'success') {
        if (type === 'selected') {
          const tempArr: string[] = [];
          data.map((val: any) => {
            tempArr.push(val.host);
          })
          props.setSelectedDevices(tempArr);
        } else if (type === 'all') {
          //props.setDevicesOfTenant(data);
        }
      }
    } catch (error) {
      console.log("getAllDevicesList error=", error);
    }
  }

  const deleteUnGroupedClassification = async (ids: any[], tenant: string, classificationName: string) => {
    try {
      const { status, data } = await apiCall(`/groups/removeDevices`, { tenant: tenant, classification: classificationName, id: ids });

      if (status === 'success') {
        props.setIsToast(true);
      } else {
        props.setToastMessage("Deletion failed");
        props.setErrorToast(true);
      }

      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setDeleteDevices(false);
      }, 100);
    } catch (error) {
      console.log("deleteUnGroupedClassification error=", error);

      props.setToastMessage("Deletion failed");
      props.setErrorToast(true);
      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setDeleteDevices(false);
      }, 100);
    }

    //   await getAttachedGroupsOfDevice({site: {_eq: tenantName}, host: {_in: ids}});

    //   device_classification.map(async (res: any) => {
    //     var finalClassification: any = '';

    //     finalClassification = res.deviceClassifications.split(",").filter((ele: any) => ele != classificationName).join(",");

    //     await updateAttachedGroupsOfDevice(tenantName, res.host, finalClassification);
    //   });

    //   props.setIsToast(true);
    //   props.setOverlayOpen(false);
    //   setTimeout(() => {
    //     props.setDeleteDevices(false);
    //   },100);
  }

  const addDevices = async (tenant: any, hosts: any, classificationName: String) => {
    try {
      const type = props.selectedValue === 1 ? 'manual' : props.selectedValue === 2 ? 'csv' : 'manual';

      const { status, data } = await apiCall(`/groups/addDevices`, { tenant: tenant, devices: hosts, classification: classificationName, type: type });

      if (status === 'success') {
        props.setIsToast(true);
      } else {
        props.setToastMessage("Operation failed");
        props.setErrorToast(true);
      }

      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setAddDevices(false);
      }, 1000);
    } catch (error) {
      console.log("addDevices error=", error);

      props.setToastMessage("Operation failed");
      props.setErrorToast(true);

      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setAddDevices(false);
      }, 100);
    }
  };

  props.deleteDevices && props.selectedRowIdInTable?.length > 0 && deleteUnGroupedClassification(props.selectedRowIdInTable, props.tenant, props.classificationName);
  props.addDevices && props.selectedRowIdInSubTable?.length > 0 && addDevices(props.tenant, props.selectedRowIdInSubTable, props.classificationName);

  if (props.selectedValue === 2 && props.devicesOfTenant === null) {
    getDevicesList({ tenant: props.tenant, function: 'export' }, 'all');
  } else if (props.selectedDevices.length === 0) {
    getDevicesList({ tenant: props.tenant, classification: props.classificationName, function: 'export' }, 'selected');
  }
}

export { Device_classification_devices_func }